import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val <= 999999999;
            return true;
        }),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formBecomingAwareThrough">
                <Form.Label>Ich bin auf diese Stelle aufmerksam geworden</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="becomingAwareThrough"
                    value={values.becomingAwareThrough}
                    isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                    isInvalid={errors.becomingAwareThrough}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThrough}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltsvorstellung jährlich</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Jährliche Gehaltsvorstellung eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formAdditionalNotes">
                <Form.Label>Persönliche Anmerkungen</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Persönliche Anmerkungen eingeben"
                    type="text"
                    name="additionalNotes"
                    value={values.additionalNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.additionalNotes && !errors.additionalNotes}
                    isInvalid={touched.additionalNotes && errors.additionalNotes}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.additionalNotes}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};